module.exports = __webpack_public_path__ + "media/giving-back/united-e52bd471.png";